import type {
  ParameterID,
  CoreProductAvailabilityResponseList,
} from '@flecto/types'

import { api } from '../../../services/api'

export type GetAllProductsAvailabilityOptions = {
  q?: string
  limit?: number
  offset?: number
  start_at: string
  end_at: string
  quantity?: number
  ignore_booking_ids?: ParameterID[]
  products?: Array<{
    id: ParameterID
    quantity: number
  }>
  order?: 'asc' | 'desc'
  sort?: 'id' | 'title' | 'price_cents' | 'booking_cost_cents' | 'created_at'
}

/**
 * Get all products availability from a store.
 *
 * @endpoint GET /api/stores/{storeDomain}/products/availability
 * @scope store
 * @see https://flecto.dev/api-4724248
 */
export async function getAllProductsAvailability(
  storeDomain: string,
  options: GetAllProductsAvailabilityOptions
): Promise<CoreProductAvailabilityResponseList> {
  const paramsUrl = new URLSearchParams()
  const optionsWithDefaults: GetAllProductsAvailabilityOptions = {
    ...options,
    offset: options.offset ?? 0,
    limit: options.limit ?? 10000,
  }

  Object.keys(optionsWithDefaults).forEach((key) => {
    // @ts-expect-error Missing type
    const param = optionsWithDefaults[key]
    if (param !== undefined && key !== 'products') {
      paramsUrl.append(key, String(param))
    }
  })

  const paramsProducts = parseProductsAvailabilityParams(options.products ?? [])

  const url = `/api/stores/${
    storeDomain
  }/products/availability?${paramsUrl.toString()}&${paramsProducts}`
  const response = await api.get<CoreProductAvailabilityResponseList>(url)
  return response.data
}

function parseProductsAvailabilityParams(
  products: GetAllProductsAvailabilityOptions['products']
): string {
  const queryStringParams: string[] = []

  products?.forEach((item) => {
    queryStringParams.push(`products[]id=${item.id}`)
    queryStringParams.push(`products[]quantity=${item.quantity}`)
  })

  return queryStringParams.join('&')
}
